import { BASE_ENDPOINT } from "../../endpoint";

export const getAllPlans = async (TOKEN) => {
  try {
    const response = await fetch(`${BASE_ENDPOINT}/api/payrollplans`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        "Content-Type": "application/json",
      },
    });
    const res = await response.json();
    if (!response.ok) {
      console.error("Error:", res);
      throw new Error(res.message);
    }
    if (Array.isArray(res)) return res;
    if (Array.isArray(res?.data)) return res.data;
    return res?.data ?? [];
  } catch (error) {
    console.error("API fetch error:", error);
    throw error;
  }
};
